export default {
  Vegan: 1,
  Vegetarian: 2,
  OpenToChange: 3,
  NoPreference: 4,
};
